// --- DATA ---
  export const personalInfo = {
    name: "Papadopoulos Panagiotis",
    title: "Electrical & Computer Engineering Undergraduate",
    location: "Thessaloniki, Greece",
    email: "panpapadopoulos00@gmail.com",
    about: "Currently studying cybersecurity and system hardening. I have worked on real-world projects, including both software and hardware.",
  };

  export const experience = [
    {
      role: "Senior Frontend Engineer",
      company: "TechFlow Solutions",
      date: "2022 - Present",
      description: [
        "Led the migration of a legacy jQuery codebase to React/Next.js, improving load times by 40%.",
        "Implemented a CI/CD pipeline using GitHub Actions that reduced deployment time from 20m to 3m.",
        "Mentored 3 junior developers and conducted weekly code reviews."
      ]
    },
    {
      role: "Software Developer Intern",
      company: "DataSystems Inc.",
      date: "2021 - 2022",
      description: [
        "Developed a Python script to automate data entry, saving the team 10+ hours per week.",
        "Collaborated with UX designers to implement accessible UI components conforming to WCAG 2.1."
      ]
    }
  ];

  export const education = [
    {
      degree: "Electrical & Computer Engineering",
      school: "Aristotle University of Thessaloniki",
      date: "2021 - current",
      details: "Thesis: Security in Federated Learning. Grade: 7.1/10"
    },
    
  ];



